import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

import { HeaderSeverityBadgeVariant } from './HeaderSeverityBadge.types'

type Tone = {
    background: string
    border: string
    color: string
}

const getTone = (severity: HeaderSeverityBadgeVariant, theme: TTheme): Tone => {
    switch (severity) {
        case 'critical':
            return {
                background:
                    theme.colors.semantic.severityBadgeCriticalBackground,
                border: theme.colors.semantic.severityBadgeCriticalBorder,
                color: theme.colors.semantic.severityBadgeCriticalText,
            }
        case 'important':
            return {
                background:
                    theme.colors.semantic.severityBadgeImportantBackground,
                border: theme.colors.semantic.severityBadgeImportantBorder,
                color: theme.colors.semantic.severityBadgeImportantText,
            }
        case 'moderate':
            return {
                background:
                    theme.colors.semantic.severityBadgeModerateBackground,
                border: theme.colors.semantic.severityBadgeModerateBorder,
                color: theme.colors.semantic.severityBadgeModerateText,
            }
        case 'low':
            return {
                background: theme.colors.semantic.severityBadgeLowBackground,
                border: theme.colors.semantic.severityBadgeLowBorder,
                color: theme.colors.semantic.severityBadgeLowText,
            }
        case 'info':
            return {
                background: theme.colors.semantic.severityBadgeInfoBackground,
                border: theme.colors.semantic.severityBadgeInfoBorder,
                color: theme.colors.semantic.severityBadgeInfoText,
            }
        case 'clean':
        default:
            return {
                background: theme.colors.greens[100],
                border: theme.colors.greens[100],
                color: theme.colors.semantic.success,
            }
    }
}

export const Badge = styled('span')<{
    severity: HeaderSeverityBadgeVariant
    theme?: TTheme
}>`
    display: inline-flex;
    align-items: center;
    height: 24px;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 4px;
    text-transform: capitalize;
    border: 0.5px solid
        ${({ theme, severity }) => getTone(severity, theme).border};
    background-color: ${({ theme, severity }) =>
        getTone(severity, theme).background};
    color: ${({ theme, severity }) => getTone(severity, theme).color};
`
